<template>
  <div class="formulario-modelo">
    <LoadingOverlay
      :visible="loading || guardandoNotas"
      :message="guardandoNotas ? 'Guardando calificaciones, esto puede tardar un momento...' : 'Cargando indicadores...'"
    />

    <MensajeFlotante
      :visible="mensajeVisible"
      :mensaje="mensajeTexto"
      :tipo="mensajeTipo"
      @cerrar="mensajeVisible = false"
    />

    <div v-if="!loading">
      <div class="header-flex">
        <div>
          <h1>Calificar Indicadores</h1>
          <p v-if="nombreVersion" class="ctx-modelo">{{ nombreVersion }}</p>
          <div v-if="tieneIndicadoresInline" class="escala-rango-hint">
            Rango de calificación: {{ escalaMin }} – {{ escalaMax }}
          </div>
        </div>
        <div class="acciones-header">
          <button
            v-if="tieneIndicadoresInline && !guardadoFinal && !todasLasNotasInlineRegistradas"
            class="btn guardar"
            :disabled="guardandoNotas"
            @click="modalConfirmVisible = true"
          >
            {{ guardandoNotas ? 'Guardando...' : 'Guardar' }}
          </button>
          <button class="btn salir" @click="salir">Salir</button>
        </div>
      </div>

      <!-- Selector de proceso cuando la versión la usan varios programas -->
      <div v-if="procesosEnEvaluacion.length > 1" class="selector-proceso">
        <template v-if="idProcesoSeleccionado === null">
          <p class="selector-aviso">Esta versión del modelo está activa en varios procesos. Seleccione el proceso que desea calificar:</p>
          <div class="selector-procesos-lista">
            <button
              v-for="p in procesosEnEvaluacion"
              :key="p.id"
              class="proceso-card"
              @click="seleccionarProceso(p.id!)"
            >
              <span class="proceso-nombre">{{ p.area?.nombre ?? p.area?.programa ?? `Programa #${p.id_programa}` }}</span>
              <span class="proceso-periodo">{{ p.periodo }}</span>
            </button>
          </div>
        </template>
        <div v-else class="proceso-activo-banner">
          <span>Calificando: <strong>{{ procesoSeleccionado?.area?.nombre ?? procesoSeleccionado?.area?.programa ?? `Proceso #${idProcesoSeleccionado}` }}</strong> · {{ procesoSeleccionado?.periodo }}</span>
          <button class="btn-cambiar-proceso" @click="idProcesoSeleccionado = null">Cambiar proceso</button>
        </div>
      </div>

      <!-- Aviso cuando no hay ningún proceso en evaluación -->
      <div v-if="!loading && procesosStore.procesos.length > 0 && procesosEnEvaluacion.length === 0" class="aviso-sin-proceso">
        No hay procesos en estado Evaluación para esta versión. Las calificaciones no se pueden guardar hasta que el proceso cambie de estado.
      </div>

      <!-- Filtros por nivel -->
      <div v-if="!loading && arbolParaVista.length > 0" class="filtros-bar">
        <div v-if="opcionesN1.length > 1" class="filtro-grupo">
          <label class="filtro-label">{{ nivelesArray[0] ?? 'Factor' }}:</label>
          <select v-model="filtroN1" class="filtro-select" @change="onCambioN1">
            <option :value="null">Todos</option>
            <option v-for="nombre in opcionesN1" :key="nombre" :value="nombre">{{ nombre }}</option>
          </select>
        </div>
        <div v-if="opcionesN2.length > 1" class="filtro-grupo">
          <label class="filtro-label">{{ nivelesArray[1] ?? 'Característica' }}:</label>
          <select v-model="filtroN2" class="filtro-select">
            <option :value="null">Todos</option>
            <option v-for="nombre in opcionesN2" :key="nombre" :value="nombre">{{ nombre }}</option>
          </select>
        </div>
        <button v-if="filtroN1 || filtroN2" class="filtro-limpiar" @click="filtroN1 = null; filtroN2 = null">
          Limpiar filtros
        </button>
      </div>

      <div class="indicadores-container">
        <div v-if="todosLosIndicadores.length === 0" class="sin-indicadores">
          <p>No hay indicadores disponibles para calificar en esta versión.</p>
        </div>
        <div v-else-if="arbolFiltrado.length === 0" class="sin-indicadores">
          <p>No hay indicadores para el filtro seleccionado.</p>
        </div>

        <!-- Nivel 1 -->
        <div v-for="(n1, i1) in arbolFiltrado" :key="i1" :class="filtroN2 ? 'nivel-transparente' : 'nivel-1-card'">
          <div v-if="!filtroN2" class="nivel-1-header">
            <span class="nivel-badge-label n1-badge">{{ nivelesArray[0] ?? 'Factor' }}</span>
            <span class="nivel-ordinal">{{ n1.ordinal || (i1 + 1) }}.</span>
            <span class="nivel-nombre">{{ n1.nombre }}</span>
          </div>
          <div :class="filtroN2 ? 'nivel-transparente' : 'nivel-body'">
            <!-- Indicadores directos en n1 (árbol plano de 1 nivel) -->
            <div v-for="indicador in n1.indicadores" :key="indicador.id_indicador" class="indicador-card">
              <div class="indicador-card-main">
                <div class="indicador-card-header">
                  <template v-if="!mismoNombrePorIndicador[indicador.id_indicador]">
                    <span class="indicador-tipo-badge">Indicador</span>
                    <h3 class="indicador-nombre">{{ indicador.enunciado ?? indicador.nombre }}</h3>
                  </template>
                  <template v-else>
                    <p class="componente-nombre">{{ nombreComponentePorIndicador[indicador.id_indicador!] }}</p>
                  </template>
                </div>
                <div v-if="!mismoNombrePorIndicador[indicador.id_indicador]" class="indicador-card-body">
                  <p v-if="indicador.unidades" class="indicador-info-item"><span class="info-label">Unidades: </span><span class="info-text">{{ indicador.unidades }}</span></p>
                  <p v-if="indicador.formula" class="indicador-info-item"><span class="info-label">Fórmula: </span><span class="info-text">{{ indicador.formula }}</span></p>
                  <p v-if="indicador.fuente_informacion" class="indicador-info-item"><span class="info-label">Fuente: </span><span class="info-text">{{ indicador.fuente_informacion }}</span></p>
                </div>
              </div>
              <div class="indicador-card-accion">
                <template v-if="mismoNombrePorIndicador[indicador.id_indicador]">
                  <div v-if="guardadoFinal || (evaluacionPorIndicador[indicador.id_indicador] != null && !indicadoresEnEdicion.includes(indicador.id_indicador!))" class="nota-inline-contenedor nota-inline-bloqueado">
                    <span class="nota-inline-label">Nota registrada</span>
                    <input type="number" class="nota-inline-input" :value="evaluacionPorIndicador[indicador.id_indicador] ?? 0" disabled />
                    <button v-if="!guardadoFinal" type="button" class="btn guardar btn-modificar-inline" @click="habilitarEdicionInline(indicador.id_indicador!)">Modificar</button>
                  </div>
                  <div v-else-if="indicadoresEnEdicion.includes(indicador.id_indicador!)" class="nota-inline-contenedor">
                    <span class="nota-inline-label">Modificar nota</span>
                    <input type="number" :min="escalaMin" :max="escalaMax" step="0.1" v-model.number="notasLocales[indicador.id_indicador!]" class="nota-inline-input" :placeholder="`${escalaMin} - ${escalaMax}`" @change="clampNota(indicador.id_indicador!)" />
                    <button type="button" class="btn guardar btn-modificar-inline" :disabled="guardandoModificacion" @click="guardarModificacionInline(indicador)">{{ guardandoModificacion ? 'Guardando...' : 'Guardar' }}</button>
                  </div>
                  <div v-else class="nota-inline-contenedor">
                    <span class="nota-inline-label">Ingrese la nota</span>
                    <input type="number" :min="escalaMin" :max="escalaMax" step="0.1" v-model.number="notasLocales[indicador.id_indicador!]" class="nota-inline-input" :placeholder="`${escalaMin} - ${escalaMax}`" @change="clampNota(indicador.id_indicador!)" />
                  </div>
                </template>
                <template v-else>
                  <div class="nota-etiqueta" :class="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null ? 'calificado' : 'pendiente'">
                    <template v-if="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null">
                      <span class="nota-etiqueta-titulo">NOTA</span>
                      <span class="nota-etiqueta-valor">{{ (evaluacionPorIndicador[indicador.id_indicador] as number).toFixed(2) }}</span>
                    </template>
                    <template v-else>
                      <span class="nota-etiqueta-linea">Pendiente</span><span class="nota-etiqueta-linea">de</span><span class="nota-etiqueta-linea">calificación</span>
                    </template>
                  </div>
                  <button v-if="indicador.id_indicador === undefined || evaluacionPorIndicador[indicador.id_indicador] == null" class="btn calificar" :disabled="procesosEnEvaluacion.length > 0 && idProcesoSeleccionado === null" @click="onCalificarIndicador(indicador)">Calificar</button>
                  <button v-if="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null" class="btn guardar btn-modificar-modal" :disabled="procesosEnEvaluacion.length > 0 && idProcesoSeleccionado === null" @click="onCalificarIndicador(indicador)">Modificar</button>
                </template>
              </div>
            </div>

            <!-- Nivel 2 -->
            <div v-for="(n2, i2) in n1.hijos" :key="i2" class="nivel-2-card">
              <div class="nivel-2-header">
                <span class="nivel-badge-label n2-badge">{{ nivelesArray[1] ?? 'Característica' }}</span>
                <span class="nivel-ordinal">{{ n2.ordinal || `${i1 + 1}.${i2 + 1}` }}.</span>
                <span class="nivel-nombre">{{ n2.nombre }}</span>
              </div>
              <div class="nivel-body">
                <!-- Indicadores directos en n2 (árbol de 2 niveles) -->
                <div v-for="indicador in n2.indicadores" :key="indicador.id_indicador" class="indicador-card">
                  <div class="indicador-card-main">
                    <div class="indicador-card-header">
                      <template v-if="!mismoNombrePorIndicador[indicador.id_indicador]">
                        <span class="indicador-tipo-badge">Indicador</span>
                        <h3 class="indicador-nombre">{{ indicador.enunciado ?? indicador.nombre }}</h3>
                      </template>
                      <template v-else>
                        <p class="componente-nombre">{{ nombreComponentePorIndicador[indicador.id_indicador!] }}</p>
                      </template>
                    </div>
                    <div v-if="!mismoNombrePorIndicador[indicador.id_indicador]" class="indicador-card-body">
                      <p v-if="indicador.unidades" class="indicador-info-item"><span class="info-label">Unidades: </span><span class="info-text">{{ indicador.unidades }}</span></p>
                      <p v-if="indicador.formula" class="indicador-info-item"><span class="info-label">Fórmula: </span><span class="info-text">{{ indicador.formula }}</span></p>
                      <p v-if="indicador.fuente_informacion" class="indicador-info-item"><span class="info-label">Fuente: </span><span class="info-text">{{ indicador.fuente_informacion }}</span></p>
                    </div>
                  </div>
                  <div class="indicador-card-accion">
                    <template v-if="mismoNombrePorIndicador[indicador.id_indicador]">
                      <div v-if="guardadoFinal || (evaluacionPorIndicador[indicador.id_indicador] != null && !indicadoresEnEdicion.includes(indicador.id_indicador!))" class="nota-inline-contenedor nota-inline-bloqueado">
                        <span class="nota-inline-label">Nota registrada</span>
                        <input type="number" class="nota-inline-input" :value="evaluacionPorIndicador[indicador.id_indicador] ?? 0" disabled />
                        <button v-if="!guardadoFinal" type="button" class="btn guardar btn-modificar-inline" @click="habilitarEdicionInline(indicador.id_indicador!)">Modificar</button>
                      </div>
                      <div v-else-if="indicadoresEnEdicion.includes(indicador.id_indicador!)" class="nota-inline-contenedor">
                        <span class="nota-inline-label">Modificar nota</span>
                        <input type="number" :min="escalaMin" :max="escalaMax" step="0.1" v-model.number="notasLocales[indicador.id_indicador!]" class="nota-inline-input" :placeholder="`${escalaMin} - ${escalaMax}`" @change="clampNota(indicador.id_indicador!)" />
                        <button type="button" class="btn guardar btn-modificar-inline" :disabled="guardandoModificacion" @click="guardarModificacionInline(indicador)">{{ guardandoModificacion ? 'Guardando...' : 'Guardar' }}</button>
                      </div>
                      <div v-else class="nota-inline-contenedor">
                        <span class="nota-inline-label">Ingrese la nota</span>
                        <input type="number" :min="escalaMin" :max="escalaMax" step="0.1" v-model.number="notasLocales[indicador.id_indicador!]" class="nota-inline-input" :placeholder="`${escalaMin} - ${escalaMax}`" @change="clampNota(indicador.id_indicador!)" />
                      </div>
                    </template>
                    <template v-else>
                      <div class="nota-etiqueta" :class="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null ? 'calificado' : 'pendiente'">
                        <template v-if="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null">
                          <span class="nota-etiqueta-titulo">NOTA</span>
                          <span class="nota-etiqueta-valor">{{ (evaluacionPorIndicador[indicador.id_indicador] as number).toFixed(2) }}</span>
                        </template>
                        <template v-else>
                          <span class="nota-etiqueta-linea">Pendiente</span><span class="nota-etiqueta-linea">de</span><span class="nota-etiqueta-linea">calificación</span>
                        </template>
                      </div>
                      <button v-if="indicador.id_indicador === undefined || evaluacionPorIndicador[indicador.id_indicador] == null" class="btn calificar" :disabled="procesosEnEvaluacion.length > 0 && idProcesoSeleccionado === null" @click="onCalificarIndicador(indicador)">Calificar</button>
                      <button v-if="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null" class="btn guardar btn-modificar-modal" :disabled="procesosEnEvaluacion.length > 0 && idProcesoSeleccionado === null" @click="onCalificarIndicador(indicador)">Modificar</button>
                    </template>
                  </div>
                </div>

                <!-- Nivel 3 (hoja típica en MAAM) -->
                <div v-for="(n3, i3) in n2.hijos" :key="i3" class="nivel-3-card">
                  <div class="nivel-3-header">
                    <span class="nivel-badge-label n3-badge">{{ nivelesArray[2] ?? 'Aspecto' }}</span>
                    <span class="nivel-ordinal">{{ n3.ordinal || `${i1 + 1}.${i2 + 1}.${i3 + 1}` }}.</span>
                    <span class="nivel-nombre">{{ n3.nombre }}</span>
                  </div>
                  <div v-for="indicador in n3.indicadores" :key="indicador.id_indicador" class="indicador-card">
                    <div class="indicador-card-main">
                      <div class="indicador-card-header">
                        <template v-if="!mismoNombrePorIndicador[indicador.id_indicador]">
                          <span class="indicador-tipo-badge">Indicador</span>
                          <h3 class="indicador-nombre">{{ indicador.enunciado ?? indicador.nombre }}</h3>
                        </template>
                        <template v-else>
                          <p class="componente-nombre">{{ nombreComponentePorIndicador[indicador.id_indicador!] }}</p>
                        </template>
                      </div>
                      <div v-if="!mismoNombrePorIndicador[indicador.id_indicador]" class="indicador-card-body">
                        <p v-if="indicador.unidades" class="indicador-info-item"><span class="info-label">Unidades: </span><span class="info-text">{{ indicador.unidades }}</span></p>
                        <p v-if="indicador.formula" class="indicador-info-item"><span class="info-label">Fórmula: </span><span class="info-text">{{ indicador.formula }}</span></p>
                        <p v-if="indicador.fuente_informacion" class="indicador-info-item"><span class="info-label">Fuente: </span><span class="info-text">{{ indicador.fuente_informacion }}</span></p>
                      </div>
                    </div>
                    <div class="indicador-card-accion">
                      <template v-if="mismoNombrePorIndicador[indicador.id_indicador]">
                        <div v-if="guardadoFinal || (evaluacionPorIndicador[indicador.id_indicador] != null && !indicadoresEnEdicion.includes(indicador.id_indicador!))" class="nota-inline-contenedor nota-inline-bloqueado">
                          <span class="nota-inline-label">Nota registrada</span>
                          <input type="number" class="nota-inline-input" :value="evaluacionPorIndicador[indicador.id_indicador] ?? 0" disabled />
                          <button v-if="!guardadoFinal" type="button" class="btn guardar btn-modificar-inline" @click="habilitarEdicionInline(indicador.id_indicador!)">Modificar</button>
                        </div>
                        <div v-else-if="indicadoresEnEdicion.includes(indicador.id_indicador!)" class="nota-inline-contenedor">
                          <span class="nota-inline-label">Modificar nota</span>
                          <input type="number" :min="escalaMin" :max="escalaMax" step="0.1" v-model.number="notasLocales[indicador.id_indicador!]" class="nota-inline-input" :placeholder="`${escalaMin} - ${escalaMax}`" @change="clampNota(indicador.id_indicador!)" />
                          <button type="button" class="btn guardar btn-modificar-inline" :disabled="guardandoModificacion" @click="guardarModificacionInline(indicador)">{{ guardandoModificacion ? 'Guardando...' : 'Guardar' }}</button>
                        </div>
                        <div v-else class="nota-inline-contenedor">
                          <span class="nota-inline-label">Ingrese la nota</span>
                          <input type="number" :min="escalaMin" :max="escalaMax" step="0.1" v-model.number="notasLocales[indicador.id_indicador!]" class="nota-inline-input" :placeholder="`${escalaMin} - ${escalaMax}`" @change="clampNota(indicador.id_indicador!)" />
                        </div>
                      </template>
                      <template v-else>
                        <div class="nota-etiqueta" :class="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null ? 'calificado' : 'pendiente'">
                          <template v-if="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null">
                            <span class="nota-etiqueta-titulo">NOTA</span>
                            <span class="nota-etiqueta-valor">{{ (evaluacionPorIndicador[indicador.id_indicador] as number).toFixed(2) }}</span>
                          </template>
                          <template v-else>
                            <span class="nota-etiqueta-linea">Pendiente</span><span class="nota-etiqueta-linea">de</span><span class="nota-etiqueta-linea">calificación</span>
                          </template>
                        </div>
                        <button v-if="indicador.id_indicador === undefined || evaluacionPorIndicador[indicador.id_indicador] == null" class="btn calificar" :disabled="procesosEnEvaluacion.length > 0 && idProcesoSeleccionado === null" @click="onCalificarIndicador(indicador)">Calificar</button>
                        <button v-if="indicador.id_indicador !== undefined && evaluacionPorIndicador[indicador.id_indicador] != null" class="btn guardar btn-modificar-modal" :disabled="procesosEnEvaluacion.length > 0 && idProcesoSeleccionado === null" @click="onCalificarIndicador(indicador)">Modificar</button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="botones-inferior">
        <button
          v-if="tieneIndicadoresInline && !guardadoFinal && !todasLasNotasInlineRegistradas"
          class="btn guardar"
          :disabled="guardandoNotas"
          @click="modalConfirmVisible = true"
        >
          {{ guardandoNotas ? 'Guardando...' : 'Guardar' }}
        </button>
        <button class="btn salir" @click="salir">Salir</button>
      </div>
    </div>

    <!-- Modal confirmación de guardado -->
    <div v-if="modalConfirmVisible" class="modal-confirm-overlay">
      <div class="modal-confirm">
        <h3 class="modal-confirm-titulo">¿Confirmar guardado?</h3>
        <p class="modal-confirm-mensaje">
          Se guardarán las notas ingresadas. Los aspectos sin nota no se modificarán y podrá completarlos después.
        </p>
        <div class="modal-confirm-botones">
          <button class="btn salir" @click="modalConfirmVisible = false">Cancelar</button>
          <button class="btn guardar" @click="confirmarGuardar">Confirmar</button>
        </div>
      </div>
    </div>

    <!-- Modal Calificar Indicador Unificado -->
    <div v-if="modalIndicadorVisible" class="modal-overlay">
      <div class="modal-contenido">
        <div class="modal-header-bar">
          <button class="modal-cerrar" @click="cerrarModalIndicador">&times;</button>
        </div>
        <div class="modal-body-scroll">
          <CalificarIndicadorUnificadoModal
            :idVersion="idVersion"
            :idIndicador="indicadorSeleccionado!"
            :idEjecucion="idProcesoSeleccionado ?? undefined"
            :escalaMax="escalaMax"
            @cerrar="cerrarModalIndicador"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Listado de indicadores pendientes de calificar.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import CalificarIndicadorUnificadoModal from '@/components/CalificarIndicadorUnificadoModal.vue'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionVersiones } from '@/store/GestionVersiones'
import useModelo from '@/store/GestionModelo'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionEvaluacionesIndicadores } from '@/store/GestionEvaluacionesIndicadores'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import useAutenticar from '@/store/IngresoAutenticar'
import type Componente from '@/interfaces/Componente'
import type Version from '@/interfaces/Versiones'
import type EstructuraModelo from '@/interfaces/EstructuraModelo'
import type Indicador from '@/interfaces/Indicador'
import { limpiarNiveles } from '@/utils/nivelesHelper'
import { useAsignacionActual } from '@/composables/useAsignacionActual'
import { useGestionIndicadorEvaluadores } from '@/store/GestionIndicadorEvaluadores'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'

const route = useRoute()
const router = useRouter()
const componentesStore = useComponentes()
const versionesStore = useGestionVersiones()
const modeloStore = useModelo()
const indicadoresStore = useGestionIndicadores()
const evaluacionesStore = useGestionEvaluacionesIndicadores()
const procesosStore = useGestionProcesos()
const authStore = useAutenticar()
const { necesitaFiltro, idsIndicadores } = useAsignacionActual()
const evaluadoresStore = useGestionIndicadorEvaluadores()
const indicadorInstrumentoStore = useGestionIndicadorInstrumentos()
const idVersion = Number(route.params.id_version ?? NaN)
const idUsuario = computed(() => authStore.usuarioActual?.id ?? null)
const procesosEnEvaluacion = computed(() =>
  procesosStore.procesos.filter(p => p.id_version === idVersion && p.estado === 'evaluacion')
)
const idProcesoSeleccionado = ref<number | null>(null)
const procesoSeleccionado = computed(() =>
  procesosEnEvaluacion.value.find(p => p.id === idProcesoSeleccionado.value) ?? null
)

const hoy = new Date().toISOString().split('T')[0]

const loading = ref(false)
const nombreVersion = ref('')
const idComponenteRaiz = ref<number | null>(null)
const nivelesArray = ref<string[]>([])
const indicadoresDeLaVersion = ref<Indicador[]>([])
const nombreComponentePorIndicador = ref<Record<number, string>>({})
const nivelComponentePorIndicador = ref<Record<number, number>>({})
const ancestoresPorIndicador = ref<Record<number, string[]>>({})
const ordinalComponentePorIndicador = ref<Record<number, string>>({})
const ordinalesAncestoresPorIndicador = ref<Record<number, string[]>>({})

function formatOrdinal(ordinal: string): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length > 1 ? parts.slice(1).join('.') : ordinal
}

// Feedback
const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('positivo')

function mostrarExito(msg: string) {
  mensajeTexto.value = msg
  mensajeTipo.value = 'positivo'
  mensajeVisible.value = true
}
function mostrarError(msg: string) {
  mensajeTexto.value = msg
  mensajeTipo.value = 'error'
  mensajeVisible.value = true
}

// Estado notas inline
const notasLocales = ref<Record<number, number | null>>({})
const guardadoFinal = ref(false)
const guardandoNotas = ref(false)
const modalConfirmVisible = ref(false)
const indicadoresEnEdicion = ref<number[]>([])
const guardandoModificacion = ref(false)

function habilitarEdicionInline(id: number) {
  if (!indicadoresEnEdicion.value.includes(id)) {
    indicadoresEnEdicion.value = [...indicadoresEnEdicion.value, id]
  }
}

async function guardarModificacionInline(indicador: Indicador) {
  const id = indicador.id_indicador!
  const rawVal = notasLocales.value[id]
  if (rawVal == null) {
    mostrarError('Ingrese una nota antes de guardar.')
    return
  }
  if (!idUsuario.value) {
    mostrarError('No se puede guardar: usuario no identificado. Vuelva a iniciar sesión.')
    return
  }
  if (!idProcesoSeleccionado.value) {
    mostrarError('Seleccione un proceso antes de guardar.')
    return
  }
  const nota = Math.min(Math.max(Number(rawVal), escalaMin.value), escalaMax.value)
  guardandoModificacion.value = true

  const resultado = await evaluacionesStore.guardarBulk({
    id_version: idVersion,
    id_ejecucion: idProcesoSeleccionado.value,
    id_usuario: Number(idUsuario.value),
    fecha_evaluacion: hoy,
    observaciones: '-',
    justificacion: '-',
    evaluaciones: [{
      id_indicador: id,
      calificacion_documental: nota,
      calificacion_cuantitativa: nota,
      calificacion_opinion: nota
    }]
  })

  guardandoModificacion.value = false

  if (!resultado.ok || resultado.errores.length > 0) {
    mostrarError('No se pudo actualizar la nota. Intente de nuevo.')
    return
  }

  indicadoresEnEdicion.value = indicadoresEnEdicion.value.filter(i => i !== id)
  await evaluacionesStore.cargar({ id_version: idVersion })
  llenarNotasLocales()
  mostrarExito('Nota actualizada correctamente.')
}
const escalaMax = ref<5 | 10>(5)
const escalaMin = computed(() => escalaMax.value === 10 ? 1 : 0)

function clampNota(id: number) {
  const v = notasLocales.value[id]
  if (v == null) return
  const min = escalaMax.value === 10 ? 1 : 0
  if (v < min) notasLocales.value[id] = min
  else if (v > escalaMax.value) notasLocales.value[id] = escalaMax.value
}


// Recorre el árbol ya cargado y asigna indicadores desde el store (sin HTTP)
function recopilarIndicadoresDesdeStore(nodos: Componente[]): Indicador[] {
  const hojas: { nodo: Componente; profundidad: number; ancestros: string[]; ordinalesAncestros: string[] }[] = []

  function recopilarHojas(lista: Componente[], profundidad: number, ancestros: string[], ordinalesAncestros: string[]) {
    const ordenados = [...lista].sort((a, b) =>
      (a.ordinal ?? '').localeCompare(b.ordinal ?? '', undefined, { numeric: true })
    )
    for (const nodo of ordenados) {
      if (nodo.children?.length) {
        recopilarHojas(
          nodo.children,
          profundidad + 1,
          [...ancestros, nodo.nombre],
          [...ordinalesAncestros, formatOrdinal(nodo.ordinal ?? '')]
        )
      } else if (nodo.id_componente) {
        hojas.push({ nodo, profundidad, ancestros, ordinalesAncestros })
      }
    }
  }
  recopilarHojas(nodos, 0, [], [])

  const resultado: Indicador[] = []
  const idsVistos = new Set<number>()
  for (const { nodo, profundidad, ancestros, ordinalesAncestros } of hojas) {
    const inds = indicadoresStore.indicadores.filter(
      i => i.id_componente === nodo.id_componente && i.id_version === idVersion && i.id_indicador != null
    )
    for (const ind of inds) {
      if (!idsVistos.has(ind.id_indicador!)) {
        idsVistos.add(ind.id_indicador!)
        resultado.push(ind)
        nombreComponentePorIndicador.value[ind.id_indicador!] = nodo.nombre
        nivelComponentePorIndicador.value[ind.id_indicador!] = profundidad
        ancestoresPorIndicador.value[ind.id_indicador!] = ancestros
        ordinalComponentePorIndicador.value[ind.id_indicador!] = formatOrdinal(nodo.ordinal ?? '')
        ordinalesAncestoresPorIndicador.value[ind.id_indicador!] = ordinalesAncestros
      }
    }
  }
  return resultado
}

onMounted(async () => {
  loading.value = true
  try {
    const version = await versionesStore.getVersionById(idVersion) as Version | null
    nombreVersion.value = version?.nombre ?? ''
    const idModelo = version?.id_modelo ?? null
    if (!idModelo) return

    // Modelo, raíz de componentes, evaluaciones, proceso activo e indicadores en paralelo
    const [modelo, raiz] = await Promise.all([
      modeloStore.getModeloById(idModelo) as Promise<EstructuraModelo | null>,
      componentesStore.cargarRaizPorModelo(idModelo),
      evaluacionesStore.cargar({ id_version: idVersion }),
      procesosStore.cargarTodos({ id_version: idVersion }),
      indicadoresStore.cargarTodos(),
      indicadorInstrumentoStore.getRelaciones()
    ])

    if (modelo?.niveles) {
      nivelesArray.value = limpiarNiveles(modelo.niveles)
    }
    if (modelo?.escala_max) {
      escalaMax.value = modelo.escala_max as 5 | 10
    }

    if (raiz?.id_componente) {
      idComponenteRaiz.value = raiz.id_componente
      await componentesStore.cargarArbolDesdeRaiz(raiz.id_componente)
    }

    // Auto-seleccionar si la versión tiene un único proceso en evaluación
    if (procesosEnEvaluacion.value.length === 1) {
      idProcesoSeleccionado.value = procesosEnEvaluacion.value[0].id ?? null
    }

    const raizNodo = componentesStore.componentes[0]
    if (raizNodo?.children?.length) {
      indicadoresDeLaVersion.value = recopilarIndicadoresDesdeStore(raizNodo.children)
    }

    llenarNotasLocales()
  } finally {
    loading.value = false
  }
})

const todosLosIndicadores = computed<Indicador[]>(() => {
  // Prioridad: asignaciones específicas de tarea 'calificar' para esta versión
  const tareasCalificar = evaluadoresStore.misAsignaciones.filter(
    a => a.tarea === 'calificar' && a.id_indicador != null && a.id_version === idVersion
  )
  if (tareasCalificar.length > 0) {
    const ids = new Set(tareasCalificar.map(a => a.id_indicador as number))
    return indicadoresDeLaVersion.value.filter(
      ind => ind.id_indicador != null && ids.has(ind.id_indicador)
    )
  }
  if (!necesitaFiltro.value) return indicadoresDeLaVersion.value
  return indicadoresDeLaVersion.value.filter(
    ind => ind.id_indicador != null && idsIndicadores.value.includes(ind.id_indicador)
  )
})

interface GrupoComponente {
  nombre: string
  ordinal: string
  ancestros: string[]
  ordinalesAncestros: string[]
  indicadores: Indicador[]
}

const gruposConIndicadores = computed<GrupoComponente[]>(() => {
  const grupos: GrupoComponente[] = []
  for (const ind of todosLosIndicadores.value) {
    const comp = nombreComponentePorIndicador.value[ind.id_indicador!] ?? ''
    const ultimo = grupos[grupos.length - 1]
    if (!ultimo || ultimo.nombre !== comp) {
      grupos.push({
        nombre: comp,
        ordinal: ordinalComponentePorIndicador.value[ind.id_indicador!] ?? '',
        ancestros: ancestoresPorIndicador.value[ind.id_indicador!] ?? [],
        ordinalesAncestros: ordinalesAncestoresPorIndicador.value[ind.id_indicador!] ?? [],
        indicadores: [ind]
      })
    } else {
      ultimo.indicadores.push(ind)
    }
  }
  return grupos
})

interface NodoArbol {
  nombre: string
  ordinal: string
  nivel: number
  hijos: NodoArbol[]
  indicadores: Indicador[]
}

const arbolParaVista = computed<NodoArbol[]>(() => {
  const raices: NodoArbol[] = []
  for (const grupo of gruposConIndicadores.value) {
    const camino = [...grupo.ancestros, grupo.nombre]
    const ordinalesCamino = [...grupo.ordinalesAncestros, grupo.ordinal]
    let nivelActual = raices
    let nodoActual: NodoArbol | undefined
    for (let i = 0; i < camino.length; i++) {
      let nodo = nivelActual.find(n => n.nombre === camino[i])
      if (!nodo) {
        nodo = { nombre: camino[i], ordinal: ordinalesCamino[i] ?? '', nivel: i, hijos: [], indicadores: [] }
        nivelActual.push(nodo)
      }
      nodoActual = nodo
      if (i < camino.length - 1) nivelActual = nodo.hijos
    }
    if (nodoActual) nodoActual.indicadores.push(...grupo.indicadores)
  }
  return raices
})

// Filtros por nivel 
const filtroN1 = ref<string | null>(null)
const filtroN2 = ref<string | null>(null)

const opcionesN1 = computed(() => arbolParaVista.value.map(n => n.nombre))

const opcionesN2 = computed(() => {
  const base = filtroN1.value
    ? arbolParaVista.value.filter(n => n.nombre === filtroN1.value)
    : arbolParaVista.value
  const vistos = new Set<string>()
  for (const n1 of base) {
    for (const n2 of n1.hijos) vistos.add(n2.nombre)
  }
  return [...vistos]
})

const arbolFiltrado = computed<NodoArbol[]>(() => {
  let arbol = arbolParaVista.value
  if (filtroN1.value) {
    arbol = arbol.filter(n1 => n1.nombre === filtroN1.value)
  }
  if (filtroN2.value) {
    arbol = arbol
      .map(n1 => ({ ...n1, hijos: n1.hijos.filter(n2 => n2.nombre === filtroN2.value) }))
      .filter(n1 => n1.hijos.length > 0 || n1.indicadores.length > 0)
  }
  return arbol
})

function onCambioN1() {
  filtroN2.value = null
}

// true = sin instrumento vinculado → modo histórico (input inline)
// false = tiene instrumento → modo normal (botón Calificar)
const mismoNombrePorIndicador = computed<Record<number, boolean>>(() => {
  const idsConInstrumento = new Set(
    indicadorInstrumentoStore.relaciones.map(r => Number(r.id_indicador))
  )
  const mapa: Record<number, boolean> = {}
  for (const ind of indicadoresDeLaVersion.value) {
    if (ind.id_indicador == null) continue
    mapa[ind.id_indicador] = !idsConInstrumento.has(ind.id_indicador)
  }
  return mapa
})

const tieneIndicadoresInline = computed(() =>
  todosLosIndicadores.value.some(
    ind => ind.id_indicador != null && mismoNombrePorIndicador.value[ind.id_indicador]
  )
)

const todasLasNotasInlineRegistradas = computed(() => {
  if (!idProcesoSeleccionado.value) return false
  const inline = todosLosIndicadores.value.filter(
    ind => ind.id_indicador != null && mismoNombrePorIndicador.value[ind.id_indicador!]
  )
  return inline.length > 0 && inline.every(
    ind => evaluacionPorIndicador.value[ind.id_indicador!] != null
  )
})

function llenarNotasLocales(): void {
  notasLocales.value = {}
  for (const ev of evaluacionesStore.evaluaciones) {
    if (idProcesoSeleccionado.value !== null && ev.id_ejecucion !== idProcesoSeleccionado.value) continue
    if (ev.id_indicador != null && ev.calificacion_final != null) {
      notasLocales.value[ev.id_indicador] = ev.calificacion_final
    }
  }
}

function seleccionarProceso(id: number): void {
  idProcesoSeleccionado.value = id
  guardadoFinal.value = false
  llenarNotasLocales()
}

// Modal calificar (modo normal)
const modalIndicadorVisible = ref(false)
const indicadorSeleccionado = ref<number | null>(null)

function onCalificarIndicador(indicador: Indicador) {
  if (!indicador?.id_indicador) return
  indicadorSeleccionado.value = indicador.id_indicador
  modalIndicadorVisible.value = true
}

async function cerrarModalIndicador() {
  modalIndicadorVisible.value = false
  indicadorSeleccionado.value = null
  await evaluacionesStore.cargar({ id_version: idVersion })
  llenarNotasLocales()
}

const evaluacionPorIndicador = computed(() => {
  const mapa: Record<number, number | null | undefined> = {}
  for (const ev of evaluacionesStore.evaluaciones) {
    if (ev.id_indicador == null) continue
    // Cuando hay proceso seleccionado, solo contar evaluaciones de ESE proceso
    if (idProcesoSeleccionado.value !== null && ev.id_ejecucion !== idProcesoSeleccionado.value) continue
    // Usar la nota final; si el backend aún no la calculó, caer a cualquier sub-nota registrada
    const nota = ev.calificacion_final ?? ev.calificacion_documental ?? ev.calificacion_cuantitativa ?? ev.calificacion_opinion
    mapa[ev.id_indicador] = nota ?? null
  }
  return mapa
})

// Guardar todas las notas inline
async function confirmarGuardar() {
  modalConfirmVisible.value = false

  if (!idUsuario.value) {
    mostrarError('No se puede guardar: usuario no identificado. Vuelva a iniciar sesión.')
    return
  }

  if (!idProcesoSeleccionado.value) {
    mostrarError('Seleccione un proceso antes de guardar.')
    return
  }

  // Solo indicadores inline con nota explícitamente ingresada (rawVal no nulo)
  const indicadoresInline = todosLosIndicadores.value.filter(
    ind => ind.id_indicador != null && mismoNombrePorIndicador.value[ind.id_indicador!]
  )

  const evaluacionesPayload = indicadoresInline
    .filter(ind => notasLocales.value[ind.id_indicador!] != null)
    .map(ind => {
      const rawVal = notasLocales.value[ind.id_indicador!]!
      const min = escalaMin.value
      const nota = Math.min(Math.max(Number(rawVal), min), escalaMax.value)
      return {
        id_indicador: ind.id_indicador!,
        calificacion_documental: nota,
        calificacion_cuantitativa: nota,
        calificacion_opinion: nota
      }
    })

  if (evaluacionesPayload.length === 0) {
    mostrarError('Ingrese al menos una nota antes de guardar.')
    return
  }

  guardandoNotas.value = true

  const resultado = await evaluacionesStore.guardarBulk({
    id_version: idVersion,
    id_ejecucion: idProcesoSeleccionado.value,
    id_usuario: Number(idUsuario.value),
    fecha_evaluacion: hoy,
    observaciones: '-',
    justificacion: '-',
    evaluaciones: evaluacionesPayload
  })

  // Preservar las notas de indicadores con error antes de recargar del servidor
  const idsConError = new Set(resultado.errores.map(e => e.id_indicador))
  const notasFallidas: Record<number, number> = {}
  for (const id of idsConError) {
    if (notasLocales.value[id] != null) notasFallidas[id] = notasLocales.value[id]!
  }

  await evaluacionesStore.cargar({ id_version: idVersion })
  llenarNotasLocales()

  // Restaurar notas que no se guardaron para que el usuario pueda reintentar
  for (const [id, nota] of Object.entries(notasFallidas)) {
    notasLocales.value[Number(id)] = nota
  }

  guardandoNotas.value = false

  if (!resultado.ok) {
    mostrarError('No se pudieron guardar las calificaciones. Intente de nuevo.')
    return
  }

  if (resultado.errores.length) {
    mostrarError('Algunas calificaciones no se pudieron guardar. Verifique sus asignaciones e intente de nuevo.')
    return
  }

  // Verificar que todas las notas enviadas quedaron registradas
  const todasConfirmadas = evaluacionesPayload.every(
    e => evaluacionPorIndicador.value[e.id_indicador] != null
  )
  if (todasConfirmadas) {
    guardadoFinal.value = indicadoresInline.every(
      ind => evaluacionPorIndicador.value[ind.id_indicador!] != null
    )
  }
  mostrarExito('Calificaciones guardadas correctamente.')
}

function salir() {
  router.push({ name: 'ProcesoAutoevaluacionUsuario' })
}
</script>

<style scoped>
.formulario-modelo {
  background-color: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  width: 95%;
  max-height: 100%;
  overflow-y: auto;
  box-shadow: var(--shadow-md);
  box-sizing: border-box;
  margin: 20px;
  font-family: var(--font-family);
}

.ctx-modelo {
  display: inline-block;
  margin: 6px 0 0;
  padding: 3px 10px;
  background: #e8f0f8;
  border-left: 3px solid #0e69a0;
  border-radius: 3px;
  font-size: 0.85rem;
  font-weight: 700;
  color: #111;
}

.header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.acciones-header {
  display: flex;
  gap: 0.5rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.btn.salir {
  background-color: white;
  border: 1px solid #ccc;
}

.btn.salir:hover {
  background-color: rgb(212, 26, 26);
  color: white;
}

.btn.guardar {
  background-color: #eea222;
  color: black;
}

.btn.guardar:hover:not(:disabled) {
  background-color: #0e69a0;
  color: white;
}

.btn.guardar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.escala-rango-hint {
  margin-top: 0.35rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #0e69a0;
}

.indicadores-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  margin-top: 1rem;
  padding: 0.5rem 0.75rem;
  max-width: 1060px;
}

.nivel-1-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #c7dff7;
  border-left: 5px solid #1a56a0;
  box-shadow: 0 2px 8px rgba(26, 86, 160, 0.08);
  overflow: hidden;
}

.nivel-1-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.85rem 1.25rem;
  background: #f0f6ff;
  font-size: 1rem;
  font-weight: 700;
  color: #1a3a6b;
  border-bottom: 1px solid #c7dff7;
}

.nivel-body {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
}

.nivel-2-card {
  background: #fafcff;
  border-radius: 8px;
  border: 1px solid #dde8f8;
  border-left: 4px solid #4a7ec7;
  overflow: hidden;
  margin-left: 1.25rem;
}

.nivel-2-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  background: #f5f8ff;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1a3a6b;
  border-bottom: 1px solid #dde8f8;
}

.nivel-3-card {
  background: #fff;
  border-radius: 6px;
  border: 1px solid #d4f0d8;
  border-left: 3px solid #4caf50;
  overflow: hidden;
  margin-left: 1.25rem;
}

.nivel-3-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.9rem;
  background: #f4fef5;
  font-size: 0.82rem;
  font-weight: 700;
  color: #1e5c24;
  border-bottom: 1px solid #d4f0d8;
}

.nivel-ordinal {
  font-size: 0.78rem;
  font-weight: 700;
  color: #555;
  min-width: 28px;
  flex-shrink: 0;
  font-variant-numeric: tabular-nums;
}

.nivel-nombre {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.nivel-badge-label {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  white-space: nowrap;
  flex-shrink: 0;
}

.n1-badge { background: #1a56a0; color: #fff; }
.n2-badge { background: #4a7ec7; color: #fff; }
.n3-badge { background: #4caf50; color: #fff; }

.indicador-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 14px 0 14px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-left: 3px solid #4caf50;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 0;
}

.indicador-card:hover {
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.09);
  transform: translateY(-1px);
}

.indicador-card-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding-right: 1.25rem;
  justify-content: center;
}

.indicador-card-header {
  margin-bottom: 0.1rem;
}

.nivel-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 12px;
  background-color: #e8f0fe;
  color: #1a56a0;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.componente-nombre {
  font-size: 0.88rem;
  font-weight: 700;
  color: #111;
  margin: 0 0 0.45rem 0;
  line-height: 1.3;
}

.indicador-tipo-badge {
  display: inline-block;
  padding: 2px 9px;
  border-radius: 12px;
  background-color: #D9FADD;
  color: #1a7f1a;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.indicador-nombre {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.1rem 0;
  line-height: 1.3;
  letter-spacing: 0.01em;
}

.indicador-card-accion {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0 20px;
  border-left: 2px solid #c8c8c8;
  min-width: 130px;
}

.nota-etiqueta {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid;
  border-radius: 4px;
  padding: 0.75rem 1.1rem;
  text-align: center;
  position: relative;
  gap: 0.2rem;
}

.nota-etiqueta::before {
  content: '';
  position: absolute;
  top: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 28px;
  height: 4px;
  border-radius: 2px;
  opacity: 0.35;
}

.nota-etiqueta.calificado {
  background-color: #f0faf2;
  border-color: #4caf50;
  color: #1e6f28;
}

.nota-etiqueta.calificado::before { background-color: #4caf50; }

.nota-etiqueta.pendiente {
  background-color: #fffdf0;
  border-color: #e0b800;
  color: #7a5c00;
}

.nota-etiqueta.pendiente::before { background-color: #e0b800; }

.nota-etiqueta-titulo {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  opacity: 0.65;
  margin-top: 0.5rem;
}

.nota-etiqueta-valor {
  font-size: 1.25rem;
  font-weight: 800;
  line-height: 1.1;
}

.nota-etiqueta-linea {
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
}

.nota-inline-bloqueado .nota-inline-label {
  color: #0e69a0;
  font-weight: 700;
}

.nota-inline-bloqueado .nota-inline-input,
.nota-inline-bloqueado .nota-inline-input:disabled {
  background-color: #ddeef8;
  border-color: #7ab8d9;
  color: #111 !important;
  -webkit-text-fill-color: #111 !important;
  cursor: not-allowed;
  opacity: 1;
}

@media (prefers-color-scheme: dark) {
  .nota-inline-bloqueado .nota-inline-input {
    background-color: rgba(14, 105, 160, 0.18);
    border-color: rgba(14, 105, 160, 0.5);
    color: #e0f0fa !important;
    -webkit-text-fill-color: #e0f0fa;
  }
  .nota-inline-bloqueado .nota-inline-label { color: #7ab8d9; }
}
:root[data-theme="dark"] .nota-inline-bloqueado .nota-inline-input {
  background-color: rgba(14, 105, 160, 0.18);
  border-color: rgba(14, 105, 160, 0.5);
  color: #e0f0fa !important;
  -webkit-text-fill-color: #e0f0fa;
}
:root[data-theme="dark"] .nota-inline-bloqueado .nota-inline-label { color: #7ab8d9; }

.nota-inline-contenedor {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.35rem;
  width: 100%;
}

.nota-inline-label {
  font-size: 0.72rem;
  font-weight: 700;
  color: #7a5c00;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.nota-inline-input {
  width: 90px;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 700;
  padding: 0.4rem 0.5rem;
  border: 2px solid #e0b800;
  border-radius: 8px;
  background: #fffdf0;
  font-family: var(--font-family);
  transition: border-color 0.15s, box-shadow 0.15s;
  appearance: none;
  -moz-appearance: textfield;
}

.nota-inline-input::-webkit-inner-spin-button,
.nota-inline-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.nota-inline-input:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 3px rgba(14, 105, 160, 0.1);
  background: #fff;
}

.nota-previa {
  font-size: 0.72rem;
  color: #999;
  text-align: center;
}

.indicador-card-body {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.indicador-info-item {
  font-size: 0.875rem;
  color: #555;
  margin: 0;
  line-height: 1.4;
}

.info-label { font-weight: 600; }
.info-text { font-weight: 400; }

.btn.calificar {
  background-color: #eea222;
  color: black;
  border: 1px solid #eea222;
  padding: 0.55rem 1.1rem;
  font-size: 0.875rem;
  white-space: nowrap;
}

.btn.calificar:hover {
  background-color: #0e69a0;
  border-color: #0e69a0;
  color: white;
}

.sin-indicadores {
  text-align: center;
  padding: 3rem 1rem;
  color: #666;
  font-size: 1.1rem;
}

.nivel-transparente {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.filtros-bar {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  flex-wrap: wrap;
  padding: 0.65rem 1rem;
  background: #f8f9fa;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  margin-bottom: 0.75rem;
}

.filtro-grupo {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.filtro-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.filtro-select {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.3rem 0.55rem;
  font-size: 0.84rem;
  font-family: var(--font-family);
  background: white;
  color: #111;
  cursor: pointer;
  min-width: 170px;
  transition: border-color 0.15s;
}

.filtro-select:focus {
  outline: none;
  border-color: #0e69a0;
  box-shadow: 0 0 0 2px rgba(14, 105, 160, 0.1);
}

.filtro-limpiar {
  background: none;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 0.3rem 0.75rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
  font-family: var(--font-family);
}

.filtro-limpiar:hover {
  border-color: #dc3545;
  color: #dc3545;
}

.modal-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.modal-confirm {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-confirm-titulo {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0 0 1rem;
  color: #111;
}

.modal-confirm-mensaje {
  font-size: 0.95rem;
  color: #444;
  margin: 0 0 1.5rem;
  line-height: 1.6;
}

.modal-confirm-botones {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

/* Modal calificar */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-contenido {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 1000px;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

.modal-header-bar {
  display: flex;
  justify-content: flex-end;
  padding: 8px 12px 0;
  flex-shrink: 0;
}

.modal-body-scroll {
  flex: 1;
  overflow-y: auto;
  padding: 0 2rem 2rem;
}

.modal-cerrar {
  background: none;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
  color: #666;
  line-height: 1;
  padding: 0 4px;
  transition: color 0.15s ease;
}

.modal-cerrar:hover {
  color: #d41a1a;
}

.botones-inferior {
  display: flex;
  justify-content: flex-start;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding: 0 0.75rem;
}

/* ── Selector de proceso ──────────────────────────────── */
.selector-proceso {
  border: 1px solid #c7dff7;
  border-radius: 10px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  background: #f0f6ff;
}

.selector-aviso {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1a3a6b;
  margin: 0 0 0.85rem;
}

.selector-procesos-lista {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.proceso-card {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.75rem 1.25rem;
  border: 2px solid #1a56a0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  text-align: left;
  font-family: var(--font-family);
  transition: all 0.15s;
  min-width: 180px;
}

.proceso-card:hover {
  background: #1a56a0;
  color: white;
}

.proceso-nombre {
  font-size: 0.9rem;
  font-weight: 700;
  color: inherit;
}

.proceso-periodo {
  font-size: 0.78rem;
  color: inherit;
  opacity: 0.75;
}

.proceso-activo-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  font-size: 0.88rem;
  color: #1a3a6b;
}

.btn-cambiar-proceso {
  font-size: 0.78rem;
  font-weight: 600;
  padding: 4px 12px;
  border: 1px solid #1a56a0;
  border-radius: 6px;
  background: white;
  color: #1a56a0;
  cursor: pointer;
  font-family: var(--font-family);
  transition: all 0.15s;
}

.btn-cambiar-proceso:hover {
  background: #1a56a0;
  color: white;
}

.aviso-sin-proceso {
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-left: 4px solid #f59e0b;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.88rem;
  color: #7a5c00;
  margin-bottom: 1rem;
}

.btn-modificar-inline {
  margin-top: 0.25rem;
  width: 100%;
  font-size: 0.82rem;
  padding: 0.35rem 0.75rem;
  height: auto;
  justify-content: center;
}

.btn-modificar-modal {
  font-size: 0.875rem;
  padding: 0.55rem 1.1rem;
  white-space: nowrap;
}
</style>
